import { configureStore } from '@reduxjs/toolkit';
import transactionsReducer from '../features/transactions/transactionsSlice';
import newPaymentReducer from '../features/newPayment/newPaymentSlice';
import accountsReducer from '../features/accounts/accountsSlice';
import beneficiarySlice from '../features/beneficiary/beneficiarySlice';
import internalSlice from '../features/transfer/internalSlice';
import usersReducer from '../features/user/userSlice';
import subUsersReducer from '../features/subUsers/subUserSlice';
import statisticReducer from '../features/transactions/statisticSlice';
import dataReducer from '../features/data/dataSlice';
import systemReducer from '../features/system/systemSlice';
import confirmModalReducer from '../features/confirmModal/confirmModalSlice';
import imageCardsReducer from '@/features/imageCards/imageCardsSlice';
import defferedTransfersSlice from '@/features/transfer/defferredTransfersSlice';
import swiftTransfersSlice from '@/features/transfer/swiftSlice';
import standingOrderReducer from '../features/standingOrder/standingOrderSlice';
import financialOperationsReducer from '../features/financialOperations/financialOperationsSlice';
import sessionReducer from '../features/session/sessionSlice';
import pendingTransactionsRecucer from '../features/pendingTransactions/pendingTransactionsSlice';
import myTransactionsReducer from '../features/myTransactions/myTransactionsSlice';
import checkbookReducer from '../features/checkbook/checkbooksSlice';
import ticketsSlice from '@/features/tickets/ticketsSlice';
import cardsReducer from '@/features/cards/cardsSlice';
import bulkTransactionsSlice from '@/features/bulkTransactions/bulkTransactionsSlice';
import paymentsReducer from '@/features/payment/paymentsSlice';
import alertsReducer from '@/features/alerts/alertsSlice';
import savingsReducer from '@/features/saving/savingSlice';
import depositsReducer from '@/features/deposits/depositsSlice';
import currencyExchangeReducer from '@/features/currencyExchange/currencyExchangeSlice';
import totpReducer from '@/features/TOTP/totpSlice';
import publicSettingsReducer from '@/features/publicSettings/publicSettingsSlice';
import termsAndConditionsReducer from '@/features/termsAndConditions/termsAndConditionsSlice';
import faqReducer from '@/features/faq/faqSlice';
import statementsReducer from '@/features/statements/statementsSlice';

export const createStore = (preloadedState?: Record<string, any>) =>
  configureStore({
    preloadedState,
    reducer: {
      transactions: transactionsReducer,
      newPayment: newPaymentReducer,
      transfer: internalSlice,
      accounts: accountsReducer,
      beneficiary: beneficiarySlice,
      users: usersReducer,
      subUsers: subUsersReducer,
      statistic: statisticReducer,
      data: dataReducer,
      system: systemReducer,
      confirmModal: confirmModalReducer,
      imageCards: imageCardsReducer,
      defferedTransfer: defferedTransfersSlice,
      swiftTransfer: swiftTransfersSlice,
      standingOrder: standingOrderReducer,
      sessions: sessionReducer,
      financialOperations: financialOperationsReducer,
      tickets: ticketsSlice,
      pendingTransactions: pendingTransactionsRecucer,
      myTransactions: myTransactionsReducer,
      checkbook: checkbookReducer,
      cards: cardsReducer,
      bulkTransactions: bulkTransactionsSlice,
      payments: paymentsReducer,
      alerts: alertsReducer,
      savings: savingsReducer,
      deposits: depositsReducer,
      currencyExchange: currencyExchangeReducer,
      totp: totpReducer,
      publicSettings: publicSettingsReducer,
      termsAndConditions: termsAndConditionsReducer,
      faq: faqReducer,
      statements: statementsReducer,
    },
  });

export const store = createStore();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
